import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import { COLORS } from "../../styles/uiConstants";
import {
  dialogPaperSx,
  dialogTitleSx,
  dialogContentSx,
  dialogMessageSx,
  dialogActionsSx,
  dialogCancelButtonSx,
  dialogConfirmButtonSx,
} from "./dialogStyles";

/**
 * Onay diyaloğu. Başlık, mesaj ve İptal / Onayla butonları.
 * @param {boolean} open
 * @param {() => void} onClose - İptal veya dışarı tıklanınca
 * @param {() => void} onConfirm - Onayla tıklanınca
 * @param {string} title
 * @param {string|React.ReactNode} message
 * @param {string} confirmText - default "Onayla"
 * @param {string} cancelText - default "İptal"
 * @param {"primary"|"error"|"warning"} confirmVariant - Onayla butonunun rengi (pasifleştir = error/warning)
 * @param {boolean} loading - Onayla'ya basıldıktan sonra loading
 * @param {string} [loadingText] - loading iken butonda gösterilecek metin (varsayılan: "İşleniyor...")
 */
export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title = "Onay",
  message,
  confirmText = "Onayla",
  cancelText = "İptal",
  confirmVariant = "primary",
  loading = false,
  loadingText = "İşleniyor...",
}) {
  const confirmColor =
    confirmVariant === "error"
      ? { bg: COLORS.error, hover: COLORS.errorDark }
      : confirmVariant === "warning"
        ? { bg: COLORS.warningDark, hover: COLORS.warningDarker }
        : { bg: COLORS.successDark, hover: COLORS.successDarker };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: dialogPaperSx }}
    >
      <DialogTitle sx={dialogTitleSx}>
        {title}
      </DialogTitle>
      <DialogContent sx={dialogContentSx}>
        <Box sx={{ paddingTop: "4px" }}>
          {typeof message === "string" ? (
            <Typography sx={dialogMessageSx}>
              {message}
            </Typography>
          ) : (
            <Box>{message}</Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={dialogActionsSx}>
        <Button
          onClick={onClose}
          disabled={loading}
          variant="outlined"
          sx={dialogCancelButtonSx}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          disabled={loading}
          variant="contained"
          startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
          sx={dialogConfirmButtonSx(confirmColor)}
        >
          {loading ? loadingText : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
